import { Box, Button, Container } from "@mui/material";
import Header from "@/app/components/header";
import Footer from "@/app/components/footer";
import { PUBLIC_PAGE_CONTAINER_MAX_WIDTH, publicPageContainerSx } from "@/app/_utils/publicLayout";

const pageBg = "#0a0a0a";
const textPrimary = "#ffffff";
const textMuted = "#999999";

export default function NotFoundSection({
  title = "Page not found",
  message = "The page you're looking for doesn't exist or is no longer available.",
  ctaLabel = "Back to Tickets",
  ctaHref = "/tickets",
}: {
  title?: string;
  message?: string;
  ctaLabel?: string;
  ctaHref?: string;
}) {
  return (
    <>
      <Header />
      <Box sx={{ bgcolor: pageBg, minHeight: "80vh" }}>
        <Container maxWidth={PUBLIC_PAGE_CONTAINER_MAX_WIDTH} sx={publicPageContainerSx}>
          <Box
            sx={{
              minHeight: "60vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              py: 10,
            }}
          >
            <Box sx={{ color: textMuted, fontWeight: 800, fontSize: 13, letterSpacing: 2, mb: 2 }}>
              404
            </Box>
            <Box
              component="h1"
              sx={{
                color: textPrimary,
                fontWeight: 900,
                fontSize: { xs: 34, md: 46 },
                lineHeight: 1.1,
                m: 0,
              }}
            >
              {title}
            </Box>
            <Box sx={{ color: "#c7c7c7", fontSize: 16, lineHeight: 1.5, maxWidth: 460, mt: 2.5 }}>
              {message}
            </Box>
            <Button
              href={ctaHref}
              variant="contained"
              disableElevation
              sx={{
                mt: 4,
                bgcolor: "#fff",
                color: "#000",
                borderRadius: 999,
                px: 3,
                py: 1.25,
                fontWeight: 700,
                textTransform: "none",
                "&:hover": { bgcolor: "#eee" },
              }}
            >
              {ctaLabel}
            </Button>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
